export const TENANT_ID = 'geisinger';
export const APP_ID = 'geisinger-web';

export const MASONRY = {
  ROOT_NODE_ID_HOME_PAGE: 'demoHomePage$root', // NEW APP TODO: Replace tenant specific node id. This is a demo home masonry container.
};
